// General
import React, { useState, useContext, useRef } from "react";

// Context
import { VehiclesContext } from "../data/vehicles/VehiclesContext";
import { DealersContext } from "../data/dealers/DealersContex";
import { useData } from "../data/general/DataContext";

// Core Components
import TablePage from "../core/TablePage";

// Modals
import VehiclesAddModal from "../modals/vehicles/VehiclesAddModal";
import VehiclesUpdateModal from "../modals/vehicles/VehiclesUpdateModal";

// PrimeReact Components
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";

// Icons
import { FaTrash, FaPencilAlt } from "react-icons/fa";

function VehiclesPage() {
    // Contextten araç verileri ve silme fonksiyonu
    const { vehiclesList, deleteVehicle } = useContext(VehiclesContext);
    const { dealersList } = useContext(DealersContext);
    const { windowMode } = useData();

    // Modal ve seçili araç state'leri
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);

    // Arama çubuğu state
    const [searchTerm, setSearchTerm] = useState("");

    const ActionMenu = ({ rowData }) => {
        const op = useRef(null);
        if (windowMode === "mobile") return null;
        return (
            <>
                <Button
                    label="..."
                    className="p-button-rounded p-button-text"
                    style={{ minWidth: "40px", fontSize: "22px", fontWeight: "bold" }}
                    onClick={(e) => op.current.toggle(e)}
                />
                <OverlayPanel ref={op} dismissable showCloseIcon={false}>
                    <div className="flex flex-col gap-0 p-2 w-32">
                        {/* Düzenle butonu */}
                        <Button
                            icon={<FaPencilAlt />}
                            label="Düzenle"
                            className="p-button-text w-full justify-start"
                            onClick={() => {
                                setSelectedVehicle(rowData);
                                setShowUpdateModal(true);
                                op.current.hide();
                            }}
                        />
                        <div className="w-full border-t border-gray-300 my-1"></div>
                        {/* Sil butonu */}
                        <Button
                            icon={<FaTrash />}
                            label="Sil"
                            className="p-button-text w-full justify-start"
                            style={{ color: "red" }}
                            onClick={() => {
                                deleteVehicle(rowData.id);
                                op.current.hide();
                            }}
                        />
                    </div>
                </OverlayPanel>
            </>
        );
    };

    // Tablo kolonları
    const columns = [
        { field: "id", header: "ID", hideInFilter: true },
        { field: "brand", header: "Marka" },
        { field: "model", header: "Model" },
        { field: "plate", header: "Plaka" },
        { field: "dealerName", header: "Bayi" },
        { field: "description", header: "Açıklama" },
        {
            header: "İşlemler",
            body: (rowData) =>
                windowMode === "mobile" ? (
                    // Mobil görünümde direkt butonlar
                    <div className="flex gap-2 mt-2 w-full">
                        <Button
                            icon={<FaPencilAlt />}
                            label="Düzenle"
                            className="flex-1"
                            style={{
                                backgroundColor: "#3b82f6",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                height: "26px",
                                fontSize: "10px",
                                justifyContent: "center",
                                gap: "4px",
                                padding: "0 6px",
                            }}
                            onClick={() => {
                                setSelectedVehicle(rowData);
                                setShowUpdateModal(true);
                            }}
                        />
                        <Button
                            icon={<FaTrash />}
                            label="Sil"
                            className="flex-1"
                            style={{
                                backgroundColor: "#ef4444",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                height: "26px",
                                fontSize: "10px",
                                justifyContent: "center",
                                gap: "4px",
                                padding: "0 6px",
                            }}
                            onClick={() => deleteVehicle(rowData.id)}
                        />
                    </div>
                ) : (
                    <ActionMenu rowData={rowData} />
                ),
            hideInFilter: true,
        },
    ];

    // Arama ve filtreleme
    const filteredVehicles = vehiclesList.filter((v) =>
        !searchTerm ||
        v.brand.toLowerCase().includes(searchTerm.toLowerCase()) ||
        v.model.toLowerCase().includes(searchTerm.toLowerCase()) ||
        v.plate.toLowerCase().includes(searchTerm.toLowerCase()) ||
        v.dealerName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Kolon filtreleme seçenekleri
    const columnFilterOptions = {
        brand: { type: "text" },
        model: { type: "text" },
        plate: { type: "text" },
        dealerName: { type: "text" },
        description: { type: "text" },
    };

    return (
        <>
            <div className="p-6">
                <TablePage
                    title="Araç Listesi"
                    subTitle="Araç ekleyebilir, düzenleyebilir veya silebilirsiniz."
                    columns={columns}
                    data={filteredVehicles}
                    defaultRows={10}
                    rowsPerPageOptions={[10, 15, 25, 50,100]}
                    showSearch
                    searchValue={searchTerm}
                    onSearchChange={(e) => setSearchTerm(e.target.value)}
                    onAdd={() => setShowAddModal(true)}
                    columnFilterOptions={columnFilterOptions}
                />
            </div>

            {/* Ekleme ve Güncelleme Modalları */}
            <VehiclesAddModal isOpen={showAddModal} onClose={() => setShowAddModal(false)} />
            <VehiclesUpdateModal
                isOpen={showUpdateModal}
                onClose={() => setShowUpdateModal(false)}
                vehicleId={selectedVehicle ? selectedVehicle.id : null}
            />
        </>
    );
}

export default VehiclesPage;
